import React, { PureComponent } from "react";
import { compose } from "redux";

import { Format } from "app/app.constants";
import { formatDate } from "utils/format.util";
import { WORK_SCHEDULE_STATUS } from "features/planner/planner.constants";
import WorkScheduleReportWorkDayWeek from "features/planner/report/workSchedule/components/WorkScheduleReportWorkDayWeek";

class WorkScheduleMonthReportWorkDay extends PureComponent {
  render() {
    const { workDay } = this.props;

    const status = workDay.get("status");

    return (
      <WorkScheduleReportWorkDayWeek
        status={status}
        title={formatDate(workDay.get("date"), Format.workSchedule)}
        flexDayCount={status === WORK_SCHEDULE_STATUS.OFF_FLEX ? 1 : 0}
      />
    );
  }
}

export default compose()(WorkScheduleMonthReportWorkDay);
